import Client from '@/api/client'
import { getConfig } from '@/app/config'
import { buildUrl } from '@/routes/utils'
import { isCurrentTokenValid } from '@/utils/auth'
import { removeItem } from '@/utils/storage'

import { InitialData } from '../domain/initial'

const client = new Client(getConfig().API_ENDPOINT ?? '')
const PASSWORD_RESET_PAGE_URL = new URL(buildUrl('/reset-password'), window.location.origin).toString()

export type LoginProps = {
  email: string
  password: string
}

export type AuthenticateResponse = {
  token: string
}

export const login = async (props: LoginProps): Promise<AuthenticateResponse> => {
  return await client.post<AuthenticateResponse>('/api/shipping/api/authenticate', props)
}

export const logout = async (): Promise<InitialData | null> => {
  removeItem('token')
  return null
}

export const getInitialData = async (): Promise<InitialData | null> => {
  if (!isCurrentTokenValid()) {
    return null
  }

  return await client.get<InitialData>('/api/shipping/initial')
}

export type RequestResetPasswordProps = {
  email: string
}

export const requestResetPassword = async (props: RequestResetPasswordProps): Promise<void> =>
  client.post<void>('/api/shipping/api/customers/requestResetPassword', {
    ...props,
    redirectTo: PASSWORD_RESET_PAGE_URL,
  })

export type ResetPasswordProps = {
  digest: string
  customer_id: string
  user_id: string
  password: string
  expiry: number
}

export const resetPassword = async ({
  digest,
  customer_id,
  user_id,
  password,
  expiry,
}: ResetPasswordProps): Promise<void> =>
  client.post<void>(`/api/shipping/api/customers/${customer_id}/users/${user_id}/resetPassword`, {
    digest,
    password,
    expiry,
  })
